export const contentCSS: string[] = [];

export const tinymceInitFull = {
  plugins:
    // TinyMCE 7: Removed deprecated plugins (fullpage, hr, imagetools, noneditable, paste, tabfocus, textpattern, toc)
    // hr, noneditable, paste, textpattern are now part of core
    'advlist anchor autolink autosave charmap code codesample directionality fullscreen help image importcss insertdatetime link lists media nonbreaking pagebreak preview quickbars save searchreplace table visualblocks visualchars wordcount',
  toolbar:
    // TinyMCE 6 renamed the block-format dropdown 'formatselect' -> 'blocks';
    // unknown toolbar items are silently skipped, so the old name loses the
    // Paragraph/Heading selector without any error.
    // eslint-disable-next-line max-len
    'blocks | bold italic strikethrough forecolor backcolor | link image media | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent | removeformat',
  // TinyMCE 7 logs an evaluation-mode warning on every editor unless the
  // open-source license is declared explicitly.
  license_key: 'gpl',
  content_css: contentCSS,
  importcss_append: true,
  image_advtab: true,
  statusbar: false,
  relative_urls: false,
  skin_url: '/assets/tinymce/skins/ui/oxide',
  base_url: '/assets/tinymce',
  suffix: '.min',
  min_height: 400,
};

export function clearEditorTags(html: string) {
  return html.replace(/<\/?(html|head|body)>/g, '').replace('<!DOCTYPE html>', '');
}
